class Customer.Dashboard.FilterEventHandler extends Backbone.View

  constructor: (filters) ->
    @countersRequestsPending = 0
    @filters = filters

  updateCounters: () ->
    filters = (filter for filter in @filters.visibleFilters() when not filter.skipsPeriodicRefresh())
    @_doUpdateCounters(filters) if filters.length > 0

  forcedUpdateCounters: (specificFilterId = null) ->
    filters = (filter for filter in @filters.visibleFilters() when specificFilterId == null || (specificFilterId != null && filter.id == specificFilterId))
    @_doUpdateCounters(filters, true) if filters.length > 0

  _doUpdateCounters: (filters, force = false) ->
    return if @updateCountsRequest?.state() is 'pending' && !force
    persisted_filters = _.select(filters, (filter) -> filter.isPersisted())
    non_persisted_filters = _.select(filters, (filter) -> !filter.isPersisted())
    @updateCountsRequest = $.ajax
      url: '/customer/dashboard/filter_count'
      type: 'POST'
      data: {
        filter_ids: _.map(persisted_filters, (filter) -> filter.id),
        additional_queries: _.map(persisted_filters, (filter) -> {
          search_text: filter.get('query').search_text,
          id: filter.get('query').id
        }),
        non_persisted_filters: _.map(non_persisted_filters, (filter) -> filter.toJSON())
      }
      global: false
      dataType: 'json'
      success: (response) =>
        for queryCount in response.queries
          filter = _.where(@filters.getFilters(), {id: queryCount.id})[0]
          if filter?
            filter.setCounter(queryCount.total, queryCount.ids)
      error: (error) =>
        console.log ("Counter update error")

  startCounter: =>
    Visibility.stop @intervalHandler if @intervalHandler
    @updateCountersWithInterval()
    @intervalHandler = Visibility.every(Customer.refreshIntervals.filterCount, @updateCountersWithInterval)

  updateCountersWithInterval: =>
      @updateCounters()
